
import CategoriesTable from 'components/Categories';
import { useSelector } from 'react-redux';
import { checkPermission } from 'utils/utils';

export const Categories = () => {
  const selectedCompanyPermission = useSelector(
    (state: any) => state?.userProfile?.data?.permissions
  );
  const isCategoriesPermission = checkPermission(selectedCompanyPermission, {
    permissionName: 'Categories',
    permission: ['viewAll'],
  });
  return <div>{isCategoriesPermission && <CategoriesTable />}</div>;
};
